// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Menu_wrapper__1nX2N"};